//   var book = await window.ePub(url || window.location.protocol + "//s3.amazonaws.com/epubjs.org/books/moby-dick-hypothesis-demo.epub");
import React, { Component, Fragment } from "react";
import "./App.css";
import Sidebar from "react-sidebar";
import { bindActionCreators } from "redux";
import { Creators as LoaderActions } from "../../store/ducks/loader";
import closeIcon from "../../assets/img/icon-fechar-menu-amarelo-weblivro.png";
import menuIcon from "../../assets/img/menu-amarelo-weblivro.png";
import { connect } from "react-redux";

class WebBookView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      book: {},
      sidebarOpen: false,
      sumarysItems: [],
      selectItem: ""
    };
    this.renderViewer = this.renderViewer.bind(this);
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    this.handleClickItemSumary = this.handleClickItemSumary.bind(this);
  }
  async renderViewer() {
    const { isLoading } = this.props;
    isLoading(true);
    var params =
      URLSearchParams &&
      new URLSearchParams(document.location.search.substring(1));
    var url =
      params && params.get("url") && decodeURIComponent(params.get("url"));
    var currentSectionIndex =
      params && params.get("loc") ? params.get("loc") : undefined;
    // Load the opf
    var book = await window.ePub(
      url ||
        window.location.protocol +
          "//a5-dashboard.herokuapp.com/images/antonina.epub"
    );
    var rendition = book.renderTo("viewer", {
      width: "100%",
      height: 600,
      spread: "always"
    });

    window.helperEbook = rendition;

    rendition.display(currentSectionIndex);
    book.ready.then(() => {
      var next = document.getElementById("next");
      next.addEventListener(
        "click",
        function(e) {
          book.package.metadata.direction === "rtl"
            ? rendition.prev()
            : rendition.next();
          e.preventDefault();
        },
        false
      );
      var prev = document.getElementById("prev");
      prev.addEventListener(
        "click",
        function(e) {
          book.package.metadata.direction === "rtl"
            ? rendition.next()
            : rendition.prev();
          e.preventDefault();
        },
        false
      );
      var keyListener = e => {
        // Left Key
        if ((e.keyCode || e.which) == 37) {
          book.package.metadata.direction === "rtl"
            ? rendition.next()
            : rendition.prev();
        }
        // Right Key
        if ((e.keyCode || e.which) == 39) {
          book.package.metadata.direction === "rtl"
            ? rendition.prev()
            : rendition.next();
        }
      };
      rendition.on("keyup", keyListener);
      document.addEventListener("keyup", keyListener, false);
    });
    var title = document.getElementById("title");
    rendition.on("rendered", section => {
      var current = book.navigation && book.navigation.get(section.href);
      if (current) {
        var $select = document.getElementById("toc");
        var $selected = $select.querySelector("option[selected]");
        if ($selected) {
          $selected.removeAttribute("selected");
        }
        var $options = $select.querySelectorAll("option");
        for (var i = 0; i < $options.length; ++i) {
          let selected = $options[i].getAttribute("ref") === current.href;
          if (selected) {
            $options[i].setAttribute("selected", "");
          }
        }
      }
    });
    rendition.on("relocated", location => {
      var next =
        book.package.metadata.direction === "rtl"
          ? document.getElementById("prev")
          : document.getElementById("next");
      var prev =
        book.package.metadata.direction === "rtl"
          ? document.getElementById("next")
          : document.getElementById("prev");
      if (location.atEnd) {
        next.style.visibility = "hidden";
      } else {
        next.style.visibility = "visible";
      }
      if (location.atStart) {
        prev.style.visibility = "hidden";
      } else {
        prev.style.visibility = "visible";
      }
    });
    rendition.on("layout", layout => {
      let viewer = document.getElementById("viewer");
      if (layout.spread) {
        viewer.classList.remove("single");
      } else {
        viewer.classList.add("single");
      }
    });
    window.addEventListener("unload", () => {
      this.book.destroy();
    });
    book.loaded.navigation.then(toc => {
      const tocs = [];
      toc.forEach((chapter, index) => {
        tocs.push({ text: chapter.label, href: chapter.href });
        /*
        var option = document.createElement("option");
        option.textContent = chapter.label;
        option.setAttribute("ref", chapter.href);
        docfrag.appendChild(option);
        */
      });
      isLoading(false);
      this.setState({ sumarysItems: tocs });
    });
  }
  async componentDidMount() {
    await this.renderViewer();
    await this.setState({ helperEbook: window.helperEbook  });
  }
  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }
  handleClickItemSumary(ref) {
    this.setState({ selectItem: ref, sidebarOpen: !this.state.sidebarOpen });
    var url = ref;
    this.state.helperEbook.display(url);
  }
  render() {
    const { sidebarOpen, sumarysItems } = this.state;
    return (
      <Fragment>
        <section className="webbookview">
          <Sidebar
            sidebar={
              <Fragment>
                <div className="webbookview__sidebar">
                  <div className="webbookview__sidebar__header">
                    <h2 className="webbookview__sidebar__header__title">
                      Sumário
                    </h2>
                    <button
                      onClick={() => this.setState({ sidebarOpen: false })}
                      className="webbookview__sidebar__header__closebutton"
                    >
                      <img
                        className="webbookview__sidebar__header__closebutton__img"
                        src={closeIcon}
                        alt="close-icon"
                      />
                    </button>
                  </div>
                  <ul className="webbookview__sidebar__sumary">
                    {sumarysItems.map(item => (
                      <li
                        onClick={e => this.handleClickItemSumary(item.href)}
                        className="webbookview__sidebar__sumary__item"
                      >
                        {item.text}
                      </li>
                    ))}
                  </ul>
                </div>
              </Fragment>
            }
            open={sidebarOpen}
            onSetOpen={this.onSetSidebarOpen}
            styles={{
              sidebar: {
                background: "white",
                width: "300px",
                position: "fixed"
              }
            }}
          >
            <button
              className="webbookview__toggle"
              onClick={() => this.setState({ sidebarOpen: true })}
            >
              <img src={menuIcon} alt="close-icon" />
            </button>
          </Sidebar>
          <div className="App">
            <select style={{ display: "none" }} id="toc" />
            <div id="viewer" className="spreads" />
            <a id="prev" href="#prev" className="arrow">
              ‹
            </a>
            <a id="next" href="#next" className="arrow">
              ›
            </a>
          </div>
        </section>
      </Fragment>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(LoaderActions, dispatch);

export default connect(
  null,
  mapDispatchToProps
)(WebBookView);



// WEBPACK FOOTER //
// ./src/pages/WebBookView/index.js